<template>
  <div v-if="showBlock" class="ftu-block card">
    <icon :name="icon" />

    <div>
      <h3 class="secondary-font">
        {{ title }}
      </h3>

      <p>{{ description }}</p>
    </div>

    <icon-button icon="close" @click="dismiss" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import * as Sentry from '@sentry/vue';

import { authService } from '@/services';

export default {
  props: {
    icon: String,
    title: String,
    description: String,
    dismissKey: String,
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    showBlock() {
      return this.user && this.user.tutorials && !this.user.tutorials[this.dismissKey];
    },
  },

  methods: {
    async dismiss() {
      try {
        await authService.updateUser(this.user.uid, {
          tutorials: {
            ...this.user.tutorials,
            [this.dismissKey]: true,
          },
        });
      } catch (e) {
        Sentry.captureException(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ftu-block {
  margin-bottom: $gp;
  position: relative;

  @media($medium-up) {
    display: flex;
    align-items: flex-start;
    padding: $gp * 2;
    margin-bottom: $gp * 2;
  }

  .icon {
    --icon-size: 50px;
    font-size: 50px;
    color: $color-green-1;
    margin-right: $gp;
    margin-bottom: $gp;

    @media($medium-up) {
      --icon-size: 100px;
      font-size: 100px;
      margin-right: $gp * 2;
    }
  }

  .icon-button {
    position: absolute;
    top: $gp;
    right: $gp;

    @media($medium-up) {
      top: $gp * 2;
      right: $gp * 2;
    }
  }
}
</style>
